import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/appState/AppState';
import {
    SportHeaderRow,
    SportHeaderRowLogo,
    SportHeaderWrapper,
    SportName,
    Loader,
    LoaderWrapper,
    SportHeaderUnifiedWrapper,
} from 'src/domains/layouts/webview/components/sportHeader/SportHeader.style';
import { CustomizedSportHeaderState } from './CustomizedSportHeaderState';
import { SportHeaderContainer } from 'src/domains/layouts/shared/SportsAndScoreboards.style';
import { useCommon } from 'src/domains/common/Common';
import { TranslationsStore } from 'src/domains/layouts/state/translationsStore/TranslationsStore';

export interface SportHeaderPropsType {
    sportId: string;
}

export const SportHeaderSimple = observer('SportHeaderStar', (props: SportHeaderPropsType) => {
    const common = useCommon();
    const { appSportsBookState, unifiedComponentConfig } = useAppStateContext();
    const { sportId } = props;
    const specialSportState = appSportsBookState.specialSportsMap.get(sportId);
    const specialExpandForSport = specialSportState.specialExpandForSport;
    const translationsStore = TranslationsStore.get(common);
    const sportName = specialExpandForSport?.label ?? translationsStore.translateSport(sportId);

    const {
        componentVariants: { sportsbookVariant },
        unifiedSportEventsTable,
    } = unifiedComponentConfig;

    const sportState = new CustomizedSportHeaderState(common, {
        sportId,
        competitionId: null,
        options: { desktopImage: null, tabletImage: null, mobileImage: null },
        name: sportName,
        isSpecialEvent: false,
        isCompetitionPage: false,
    });

    const sportHeaderDetails = sportState.getSportDetails;
    const SportHeaderWrapperComponent = unifiedSportEventsTable ? SportHeaderUnifiedWrapper : SportHeaderWrapper;

    return (
        <>
            <SportHeaderContainer variant={sportsbookVariant}>
                {sportState.isLoading === true ? (
                    <LoaderWrapper variant={sportsbookVariant}>
                        <Loader />
                    </LoaderWrapper>
                ) : (
                    <SportHeaderWrapperComponent
                        hasImage={sportState.isActiveHeaderImage}
                        bgColor={sportHeaderDetails?.header_bg_color}
                        isCustomImgDesktop={sportState.isCustomImgDesktop}
                        isCustomImgTablet={sportState.isCustomImgTablet}
                        isCustomImgMobile={sportState.isCustomImgMobile}
                        backgroundImgDesktop={sportState.headerImgDesktop}
                        backgroundImgTablet={sportState.headerImgTablet}
                        backgroundImgMobile={sportState.headerImgMobile}
                        data-test='sport-header-wrapper'
                    >
                        <SportHeaderRow
                            hasImage={sportState.isActiveHeaderImage}
                            textColor={sportHeaderDetails?.sport_label_color}
                            variant={sportsbookVariant}
                        >
                            {sportName === 'American Football' ? <SportHeaderRowLogo /> : null}
                            <SportName hasImage={sportState.isActiveHeaderImage}>
                                {sportHeaderDetails?.sport_label ?? sportName}
                            </SportName>
                        </SportHeaderRow>
                    </SportHeaderWrapperComponent>
                )}
            </SportHeaderContainer>
        </>
    );
});
